import request from '@/utils/request'

// --------------------------------------------------------------------------个人中心----------------------------------------------------------------------------------
// 获取个人信息
export function personalInfo(data) {
  return request({
    url: '/oa/personalInfo/get',
    method: 'get',
    data
  })
}
// 更新个人信息
export function updatePersonalInfo(data) {
  return request({
    url: '/oa/personalInfo/update',
    method: 'post',
    data
  })
}
// 保存用户签名
export function saveUserSignatrue(data) {
  return request({
    url: '/system/users/saveUserSignatrue',
    method: 'post',
    data
  })
}
